import React, { useCallback, useEffect, useRef, useState } from 'react';

import * as Atoms from 'components/Atoms';
import * as Molecules from 'components/Molecules';
import * as Organisms from 'components/Organisms';
import { ModalSecondAccess } from './ModalSecondAccess';

import ImageHardcoded1 from './Assets/1.svg';
import ImageHardcoded2 from './Assets/2.png';
import ImageHardcoded3 from './Assets/3.png';
import ImageHardcoded4 from './Assets/4.png';
import ImageHardcoded5 from './Assets/5.png';
import ImageHardcoded6 from './Assets/6.png';
import WhiteMarker from 'assets/images/marker/white.svg';
import * as S from './styles';
import * as T from './interfaces';

export const MenuRestaurant: React.FC<T.IMenuRestaurant> = ({
  backgroundChange,
  containerRef,
  hideBanner,
  hideSearch,
  onPressChooseRestaurant,
  onPressAnyCategoryFilter,
  categories,
  storeSelected,
  hideModalSecondAccess,
  openModalSecondAccess,
  handleClickProduct,
}) => {
  const StatusList = [
    { id: 1, type: 0, caracteristics: '12 Pedaços' },
    { id: 2, type: 0, caracteristics: 'suave' },
  ];
  const items = [
    {
      labels: StatusList,
      name: 'Gigante',
      image_url: ImageHardcoded1,
      isDisabled: false,
      price: 28.9,
      unavailable: false,
    },
    {
      labels: StatusList,
      name: 'Grande',
      image_url: ImageHardcoded2,
      isDisabled: false,
      price: 28.9,
      unavailable: false,
    },
    {
      labels: StatusList,
      name: 'Mini filés',
      image_url: ImageHardcoded3,
      isDisabled: false,
      price: 28.9,
      unavailable: true,
    },
    {
      labels: StatusList,
      name: 'Mini filés',
      image_url: ImageHardcoded3,
      isDisabled: false,
      price: 28.9,
      unavailable: false,
    },
    {
      labels: StatusList,
      name: `Balde 2 em 1
      + molho`,
      image_url: ImageHardcoded5,
      isDisabled: false,
      price: 28.9,
      unavailable: false,
    },
    {
      labels: StatusList,
      name: 'Batata Cajun',
      image_url: ImageHardcoded6,
      isDisabled: false,
      price: 28.9,
      unavailable: false,
    },
  ];

  return (
    <S.Container ref={containerRef}>
      <ModalSecondAccess
        open={openModalSecondAccess}
        onClose={hideModalSecondAccess}
        nameStore={storeSelected && storeSelected.name}
      />
      <Organisms.HeaderMenu
        id="menuRestaurant"
        hideBanner={hideBanner}
        hideSearch={hideSearch}
        onPressAnyCategoryFilter={onPressAnyCategoryFilter}
        storeSelected={storeSelected}
      />
      <S.MenuitemContainer>
        {categories.length > 0 &&
          categories.map(category => (
            <S.MenuCategoryContainer
              key={category.id}
              id={category.name}
              hideBackButtonMobile={!!storeSelected?.name}
            >
              <span>{category.name}</span>
              <S.MenuCategoryItem>
                {category.skus.length > 0 &&
                  category.skus.map(product => (
                    <Molecules.MenuItem
                      key={product.sku}
                      id={`${product.id}`}
                      labels={
                        product.caracteristics.length > 0 &&
                        product.caracteristics.map(
                          status => status.caracteristics,
                        )
                      }
                      title={product.name}
                      img={product.image}
                      price={product.price && product.price}
                      isDisabled={false}
                      unavailable={!product.ruptures.enabled}
                      imgOutsideContainer
                      onClick={() => handleClickProduct(product.id)}
                    />
                  ))}
              </S.MenuCategoryItem>
            </S.MenuCategoryContainer>
          ))}
        <S.ChooseRestaurant hideButton={!hideBanner}>
          <Atoms.Button
            id="chooseRestaurant"
            title="Escolha um restaurante"
            variant="menu"
            font="bold"
            icon={WhiteMarker}
            altIcon="Ícone de mapa do botão"
            onClick={onPressChooseRestaurant}
          >
            Escolha um restaurante
          </Atoms.Button>
        </S.ChooseRestaurant>
      </S.MenuitemContainer>
    </S.Container>
  );
};
